import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';

import { arSA, enUS } from 'date-fns/locale';

import 'react-image-lightbox/style.css';
import './index.scss';

import * as serviceWorker from './app/serviceWorker';

import DateFnsUtils from '@date-io/date-fns';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { constants, getFromLocalStorage } from 'app/utils/localStorage';
import { AuthProvider } from 'app/context/auth';
import ReactQueryProvider from 'app/context/react-query-provider';
import { SnackbarProvider } from 'notistack';
import { DarkModeContextProvider } from 'app/context/DarkModeContext';

const container = document.getElementById('body');
const root = createRoot(container);
const lang = getFromLocalStorage(constants.language);

const langMap: any = {
  en: enUS,
  ar: arSA,
};
root.render(
  <BrowserRouter>
    <DarkModeContextProvider>
      <MuiPickersUtilsProvider locale={langMap[lang]} utils={DateFnsUtils}>
        <ReactQueryProvider>
          <AuthProvider>
            <SnackbarProvider
              maxSnack={5}
              style={{
                background: '#F7F7F7',
                border: '1px solid var(--borderColor)',
                color: 'var(--mainColor)',
                width: '357px',
                height: 'max-content',
                boxShadow: 'none',
                borderRadius: 0,
                paddingInline: 20,
                fontFamily: 'inherit',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: lang === 'en' ? 'right' : 'left',
              }}
            >
              <App />
            </SnackbarProvider>
          </AuthProvider>
        </ReactQueryProvider>
      </MuiPickersUtilsProvider>
    </DarkModeContextProvider>
  </BrowserRouter>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
